import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

interface TableCellTooltipProps {
  children: React.ReactNode;
  tooltip: string;
  className?: string;
  truncate?: boolean;
}

export const TableCellTooltip: React.FC<TableCellTooltipProps> = ({
  children,
  tooltip,
  className = '',
  truncate = true,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={`${truncate ? 'truncate' : ''} ${className}`}>
          {children}
        </div>
      </TooltipTrigger>
      <TooltipContent className="bg-gray-900 text-white border-gray-700">
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};
